module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"fields":{"name":"Name","isActive":"Active"},"toaster":{"errorTitle":"Error"}},"hr":{"fields":{"name":"Naziv","isActive":"Aktivan"},"toaster":{"errorTitle":"Greška"}}}')
  delete Component.options._Ctor
}
